import { notification } from 'antd'
import {getAlertResumeByClClientService} from '../services/getAlertResumeByClClientService'

export const getAlertResumeByClClientPromise= (dataRange) => {
	return new Promise(resolve => {
		getAlertResumeByClClientService(dataRange)
			.then(response => resolve({ success: true, data: response.data }))
			.catch(error => {notification.error({message: "Alert Resume : "+error.message})})
	})
}

